import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useId } from "react";
import { useController } from "react-hook-form";

export type LabeledSwitchProps = React.ComponentProps<"button"> & {
  labelText: string;
  name: string;
};

export const LabeledSwitch = ({
  className,
  labelText,
  ...props
}: LabeledSwitchProps): JSX.Element => {
  const { field } = useController({ name: props.name });
  const uid = useId();

  const handleChange = (checked: boolean): void => {
    field.onChange(checked);
  };

  return (
    <div className={className}>
      <Switch
        defaultChecked={field.value as boolean}
        id={uid}
        onCheckedChange={handleChange}
        {...props}
      />
      <Label className="ms-2 leading-0" htmlFor={uid}>
        {labelText}
      </Label>
    </div>
  );
};
